import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Vas from '../Vas';
import $ from 'jquery';
import "../css/ChangePassword.css";

import { ExtendedButton,TextField,Icon,MessageBox } from 'component-lib';

import { CheckPassword,CheckValues } from 'utils-lib';

import { RequestAjaxClass,PasswordModel,AccountsModel } from 'models-lib';

class ChangePassword  extends Component {

  constructor(props)
  {
    super(props);
    this.state = {};
    this.state.OldPassword = "";
    this.state.NewPassword = "";
    this.state.RetypedNewPassword = "";

    this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    this.PasswordModel = new PasswordModel([this]);
    this.AccountsModel = new AccountsModel([this]);
  }

  componentDidMount(){
    this.Request.setApiUrl(Vas.ApiUrl);
    this.Request.setApiKey(Vas.ApiKey);
    this.Request.setAuth(true);
    this.Request.setErrorHandler(()=>{
      $("#LoadingIconPopUp").removeClass().addClass('hide');
    });
    this.PasswordModel.SetRequest(this.Request);
    this.AccountsModel.SetRequest(this.Request);

    this.PasswordModel.GetPaswordPolicy();
    this.setState({ requiredFields:[this.refs.oldPassword, this.refs.newPassword, this.refs.retypePassword] });
  }

  Update(observer)
  {
    let me = this;
    this.setState({},()=>{
      if(observer === "PaswordPolicy"){
        
          ReactDOM.render(
            <table id={"policyDescription"}>
              <tbody>
                <tr>
                  <td colSpan={3}>{Vas.Resources.Labels["PasswordPolicy"]}</td>
                </tr>
                <tr>
                  <td>{Vas.Resources.Labels["AtLeast"]}</td>
                  <td>{this.PasswordModel.PasswordLength}</td>
                  <td>{Vas.Resources.Labels["Char"]}</td>
                </tr>
                <tr>
                  <td>{Vas.Resources.Labels["AtLeast"]}</td>
                  <td>{this.PasswordModel.CountMinNumbers}</td>
                  <td>{Vas.Resources.Labels["AtLeastNumbers"]}</td>
                </tr>
                <tr>
                  <td>{Vas.Resources.Labels["AtLeast"]}</td>
                  <td>{this.PasswordModel.CountMinLetters}</td>
                  <td>{Vas.Resources.Labels["AtLeastChars"]}</td>
                </tr>
                <tr>
                  <td>{Vas.Resources.Labels["AtLeast"]}</td>
                  <td>{this.PasswordModel.CcountLowerCaseLetters}</td>
                  <td>{Vas.Resources.Labels["AtLeastLowerChars"]}</td>
                </tr>
                <tr>
                  <td>{Vas.Resources.Labels["AtLeast"]}</td>
                  <td>{this.PasswordModel.CcountUpperCaseLetters}</td>
                  <td>{Vas.Resources.Labels["AtLeastUpperChars"]}</td>
                </tr>
                <tr>
                  <td>{Vas.Resources.Labels["AtLeast"]}</td>
                  <td>{this.PasswordModel.CountMinSpecialCharacters}</td>
                  <td>{Vas.Resources.Labels["AtLeastSymbols"]}</td>
                </tr>
              </tbody>
            </table>
            ,document.getElementById("policy"));
          me.setState({ PasswordModus:[this.PasswordModel.PasswordLength,
                                       this.PasswordModel.CcountNumbers,
                                       this.PasswordModel.CountLetters,
                                       this.PasswordModel.CcountLowerCaseLetters,
                                       this.PasswordModel.CountUpperCaseLetters,
                                       this.PasswordModel.CountMinSpecialCharacters] });
      }
      else if(observer === "ChangePassword"){
        $("#LoadingIconPopUp").removeClass().addClass('hide');
        localStorage.setItem('vas_token',this.PasswordModel.Token);
        
        this.AccountsModel.Own();
      }
      else if(observer === "AccountsOwn"){
        localStorage.setItem("vas_customerId", this.AccountsModel.Customer.Id);
        Vas.GetView("ChangePasswordSuccess",null,true);
      }
    });
  }

  checkFields(){
    if (this.state.requiredFields){
      let count = this.state.requiredFields.length;
      let filled = 0;

      for (let i = 0;i < this.state.requiredFields.length;i++){
        if (this.state.requiredFields[i]){
          if (document.getElementById(this.state.requiredFields[i].props.Id).value.length > 0){
            filled++;
          }
        }
      }
      if (filled < count){
        let docs = document.querySelectorAll('select,input');
        let docRefs = this.refs;
        CheckValues.checkAllFields(docs,docRefs,"");
        ReactDOM.render(<MessageBox 
          Message={Vas.Resources.Labels["NotAllFields"]} 
          Title={Vas.Resources.Titles["Note"]} 
        />,document.getElementById('messageContainer'));
      } else {
        $("#error1").removeClass().addClass("hide");
        $("#error2").removeClass().addClass("hide");
        $("#error3").removeClass().addClass("hide");

        if (this.refs.IconPassword.state.Name !== "Done"){
          $("#error3").removeClass().addClass("show");
        } else {
          if (document.getElementById(this.refs.oldPassword.props.Id).value === document.getElementById(this.refs.newPassword.props.Id).value){
            $("#error1").removeClass().addClass("show");
          } else {
            if (document.getElementById(this.refs.retypePassword.props.Id).value !== document.getElementById(this.refs.newPassword.props.Id).value){
              $("#error2").removeClass().addClass("show");
            } else {
              this.ChangePassword();
            }
          }
        }
      }
    }
  }

  ChangePassword(){
    $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
    this.setState({ OldPassword:document.getElementById("oldPassword").value, NewPassword:document.getElementById("newPassword").value,RetypedNewPassword:document.getElementById("retypePassword").value }, ()=>{
      this.PasswordModel.ChangePassword(this.state.OldPassword,this.state.NewPassword);
    });
  }

  Close(){
    ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
    $("#Content").css("opacity", "1");
  }

  CheckPassword(){
    if (document.getElementById(this.refs.newPassword.props.Id).value.length > 0){
      if (CheckPassword.Check(document.getElementById(this.refs.newPassword.props.Id).value,this.state.PasswordModus) === true){
        this.refs.IconPassword.setState({ Name:"Done",Color:"green" });
      } else {
        this.refs.IconPassword.setState({ Name:"Warning",Color:"red" });
      }
    } else {
      this.refs.IconPassword.setState({ Name:"Warning",Color:"red" });
    }
  }

  render()
  {
    return (
      <div className={"form"} >
        <table style={{ width:'100%' }}>
          <thead>
            <tr>
              <th >
              {Vas.Resources.Labels["ChangePassword"]}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr><td><TextField 
              AppURL={Vas.ApplicationUrl} 
              Id="oldPassword" 
              ref={"oldPassword"} 
              name="oldPassword" 
              Type={"password"} 
              Editable={true} 
              IsRequired={true} 
              Label={Vas.Resources.Labels["CurrentPassword"]} 
              OnBlur={(e,val)=>{ this.setState({ OldPassword: val });}} 
            /><br /></td></tr>
            <tr><td>
              <table>
                <tbody>
                  <tr>
                    <td><TextField 
                      AppURL={Vas.ApplicationUrl} 
                      Id="newPassword" 
                      ref={"newPassword"} 
                      name="newPassword" 
                      Type={"password"} 
                      Editable={true} 
                      IsRequired={true} 
                      Label={Vas.Resources.Labels["NewPassword"]} 
                      OnBlur={(e,value)=>{ this.setState( { NewPassword: value });}} 
                      OnChange={()=>{this.CheckPassword();}} 
                    /></td>
                    <td><Icon 
                      ref={"IconPassword"} 
                      Name={"Warning"} 
                      Size={24} 
                      Color={"red"} 
                    /></td>
                  </tr>
                </tbody>
              </table>
            </td></tr>
            <tr><td><TextField 
              AppURL={Vas.ApplicationUrl} 
              Id="retypePassword" 
              ref={"retypePassword"} 
              name="retypePassword" 
              Type={"password"} 
              Editable={true} 
              IsRequired={true} 
              Label={Vas.Resources.Labels["NewPassword2"]} 
              OnChange={(e,value)=>{ this.setState( { RetypedNewPassword: value });}} 
            /></td></tr>
            <tr><td 
              id={"policy"} 
              className={"ConfirmationLabel"}>
            </td></tr>
            <tr><td 
              id={"error1"} 
              className={"hide"} 
              style={{ color:"red" }}>{Vas.Resources.Labels["PasswordOldNew"]}
            </td></tr>
            <tr><td 
              id={"error2"} 
              className={"hide"} 
              style={{ color:"red" }}>{Vas.Resources.Labels["PasswordNotMatch"]}
            </td></tr>
            <tr><td 
              id={"error3"} 
              className={"hide"} 
              style={{ color:"red" }}>{Vas.Resources.Labels["PasswordSave"]}
            </td></tr>
            <tr><td><ExtendedButton 
              Usable={true} 
              ref={"btoChange"} 
              Text={Vas.Resources.Labels["ChangePassword"]} 
              OnClick={()=>{this.checkFields(); }} 
              style={{ margin: 25 }} 
            />
            </td></tr>
          </tbody>
        </table>
      </div>
    );
  }
}
export default ChangePassword;
